import type * as React from 'react'
import type { FC, PropsWithChildren } from 'react'

import { Dialog, DialogOverlay, DialogPortal } from '../Dialog/Dialog'

export interface ModalProps {
  /** Modal open state */
  open?: boolean
  /** Callback to run when close button or background is clicked */
  onClose?: () => void
  disableBlur?: boolean
}

export const Modal: FC<PropsWithChildren<ModalProps>> = ({
  open = false,
  disableBlur,
  children,
  onClose,
}) => {
  const closeHandler = () => {
    if (onClose) {
      onClose()
      return
    }
    console.warn('No close handler registered for dialog')
  }
  return (
    <Dialog
      modal
      open={open}
      onOpenChange={open => {
        if (!open) {
          closeHandler()
        }
      }}
    >
      <DialogPortal data-slot="dialog-portal">
        <DialogOverlay hidden={disableBlur} />
        {children}
      </DialogPortal>
    </Dialog>
  )
}
